import { createSelector } from '@reduxjs/toolkit';

/**
 * Memoized selector that combines all accounting integration page data.
 * Prevents unnecessary re-renders by only updating when actual data changes.
 */
export const selectAccountingIntegrationPageContext = createSelector(
  [(state) => state.accountingIntegrationStore, (state) => state.userStore],
  (accountingIntegrationStore, userStore) => ({
    // Enrolment status
    enrolmentStatus: accountingIntegrationStore.enrolmentStatus,

    // User context
    assignedGrandfatherClientNumber: userStore.assignedGrandfatherClientNumber,
    loggedInUser: userStore.loggedInUser,
    assignedAccountNumber: userStore.assignedAccountNumber,

    // Permissions
    readOnly: !userStore.canReadWriteAccounts,

    // MYOB Login URI
    myobLoginUri: accountingIntegrationStore.myobLoginUri,
    myobLoginUriLoading: accountingIntegrationStore.myobLoginUriLoading,
    myobLoginUriLoaded: accountingIntegrationStore.myobLoginUriLoaded,
    myobLoginUriError: accountingIntegrationStore.myobLoginUriError,

    // MYOB Disconnect
    myobDisconnectLoading: accountingIntegrationStore.myobDisconnectLoading,
    myobDisconnectLoaded: accountingIntegrationStore.myobDisconnectLoaded,

    // Xero Login URI
    xeroLoginUri: accountingIntegrationStore.xeroLoginUri,
    xeroLoginUriLoading: accountingIntegrationStore.xeroLoginUriLoading,
    xeroLoginUriLoaded: accountingIntegrationStore.xeroLoginUriLoaded,
    xeroLoginUriError: accountingIntegrationStore.xeroLoginUriError,

    // Xero Disconnect
    xeroDisconnectLoading: accountingIntegrationStore.xeroDisconnectLoading,
    xeroDisconnectLoaded: accountingIntegrationStore.xeroDisconnectLoaded,
  })
);
